// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1094":"5dd5b6f6a484c0f00b74","1236":"f5816358b23e4d4a2606"}[chunkId] + ".js";
};